/**
 * Utility function to format a Date object to a YYYY-MM-DD string.
 * This function avoids timezone conversion issues by manually constructing the date string.
 *
 * @param date - The Date object to format.
 * @returns A string in the format YYYY-MM-DD.
 * @throws Will throw an error if the provided date is invalid.
 */
export const formatYYYYMMDD = (date: Date): string => {
  if (isNaN(date.getMonth())) {
    throw new Error('Invalid date object provided')
  }

  // We must manually format the date to avoid adjustments due to timezone conversions that can occur with toISOString
  return (
    date.getFullYear() +
    '-' +
    String(date.getMonth() + 1).padStart(2, '0') +
    '-' + // Months are zero-indexed
    String(date.getDate()).padStart(2, '0')
  )
}
